import { superFetch } from 'commons'

export const fetchOrganisations = () =>
    superFetch({ url: `organisation` })

export const fetchAdminUsers = (organisationId) =>
    superFetch({ url: `utilisateurs/organisation/${organisationId}/admins` })